import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["error", "field", "filterFamily", "inputUse", "options", "resolver", "specialOptions", "onBlur", "onChange", "getIsUngated"];
import { List, Map as ImmutableMap } from 'immutable';
import PropertyOptionRecord from 'customer-data-objects/property/PropertyOptionRecord';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ReferenceInputEnum from 'customer-data-reference-ui-components/ReferenceInputEnum';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message

import { FormControl } from 'foundations-components/transitional/components/FormControl';
import isEmpty from 'transmute/isEmpty';
import I18n from 'I18n';
import { allowedProps, filterInputProps } from './filterInputProps';
import { isExternalOptionsField } from 'customer-data-filters-ui/utils/isExternalOptionsField';
import FilterOperatorExternalOptionInput from './FilterOperatorExternalOptionInput';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message

import { virtualizedMenuRenderer } from 'foundations-components/transitional/utils/virtualizedMenuRenderer';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const tryConvertMapToPropertyOptionRecord = m => {
  const propertyOption = ImmutableMap.isMap(m) ? m.toJS() : m;
  return PropertyOptionRecord(propertyOption);
};
const getOptions = (options, specialOptions, resolver) => {
  // Some resolvers supply a map. When a map is provided the label is lost,
  // so we must convert them to PropertyOptionRecords
  const safeOptions = options && options.map(tryConvertMapToPropertyOptionRecord);
  if (resolver) {
    return List.isList(specialOptions) ? specialOptions : List();
  }
  if (List.isList(safeOptions) && List.isList(specialOptions)) {
    return specialOptions.concat(safeOptions);
  }
  if (isEmpty(safeOptions) && List.isList(specialOptions)) {
    return specialOptions;
  }
  return safeOptions || List();
};
export default function FilterOperatorEnumInput(_ref) {
  let {
      error,
      field,
      filterFamily,
      inputUse,
      options,
      resolver,
      specialOptions,
      onBlur,
      onChange,
      getIsUngated
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isOpen, setIsOpen] = useState(false);
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const onOpenChange = evt => {
    setIsOpen(evt.target.value);
    if (evt.target.value === false && onBlur) {
      onBlur();
    }
  };
  const onChangeLocal = evt => {
    onChange(evt, isOpen);
  };
  const uiFormControlProps = {
    'aria-label': I18n.text('customerDataFiltersUI.customerDataFilters.FilterOperatorInput.ariaLabel'),
    error: isError,
    validationMessage: isError ? errorMessage : null
  };
  const inputProps = Object.assign({}, filterInputProps(rest, [...allowedProps, 'multi']), {
    menuRenderer: virtualizedMenuRenderer,
    onChange: onChangeLocal,
    onOpenChange,
    options: getOptions(options, specialOptions, resolver),
    resolver,
    // HACK: prevent ESC key presses from propagating up and cancelling changes
    // See https://git.hubteam.com/HubSpot/UIComponents/issues/9877
    onKeyDown: e => e.stopPropagation(),
    onKeyPress: e => e.stopPropagation(),
    onKeyUp: e => e.stopPropagation()
  });
  if (isExternalOptionsField(field, filterFamily, getIsUngated)) {
    // @ts-expect-error we improved the type of `filterInputProps` so this unsafe cast became explicit
    const multi = inputProps.multi;
    return /*#__PURE__*/_jsx(FilterOperatorExternalOptionInput, Object.assign({}, inputProps, {
      multi: multi,
      inputUse: inputUse,
      uiFormControlProps: uiFormControlProps
    }));
  } else {
    return /*#__PURE__*/_jsx(FormControl, {
      "aria-label": uiFormControlProps['aria-label'],
      error: uiFormControlProps.error,
      validationMessage: uiFormControlProps.validationMessage,
      children: /*#__PURE__*/_jsx(ReferenceInputEnum, Object.assign({}, inputProps, {
        buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined
      }))
    });
  }
}